<script setup lang="ts">
const { t } = useI18n();
interface AuthButtonProps {
  redirectUrl?: string;
  buttonClass?: string;
}

const props = defineProps<AuthButtonProps>();
</script>

<template>
  <div>
    <slot>
      <div class="flex items-center justify-center flex-row-reverse text-center lg:flex-row">
        <AuthButton
          mode="sign-in"
          type="icon"
          :redirect-url="props.redirectUrl"
          :title="t('labels.sign_in')"
          class="mx-6 text-button-bold text-main w-full lg:w-auto lg:flex-shrink-0 max-lg:hidden"
          :class="props.buttonClass"
        />
        <AuthButton
          mode="sign-up"
          size="large"
          class="text-button-bold min-w-32 lg:w-auto lg:flex-shrink-0 max-lg:mx-6"
          :title="t('labels.sign_up')"
          :class="props.buttonClass"
        />
      </div>
    </slot>
  </div>
</template>
